// extracted by mini-css-extract-plugin
module.exports = {"accountMenu":"styles_accountMenu__tpzew","customPopoverOffset":"styles_customPopoverOffset__fUgsM","userMenu":"styles_userMenu__H2CV3","userName":"styles_userName__TA__s"};